import { render, staticRenderFns } from "./PricePacketPeriod.vue?vue&type=template&id=666d5d5c&scoped=true&"
import script from "./PricePacketPeriod.vue?vue&type=script&lang=js&"
export * from "./PricePacketPeriod.vue?vue&type=script&lang=js&"
import style0 from "./PricePacketPeriod.vue?vue&type=style&index=0&id=666d5d5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d5d5c",
  null
  
)

export default component.exports